import { render, staticRenderFns } from "./userview.vue?vue&type=template&id=7e060732&scoped=true&"
import script from "./userview.vue?vue&type=script&lang=js&"
export * from "./userview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e060732",
  null
  
)

export default component.exports